import type { CptByAccountPhysicianRow } from "../services/reports.service";

export interface GroupedCptAccountPhysicianRow {
  row: CptByAccountPhysicianRow;
  accountRowSpan: number;
  physicianRowSpan: number;
  prefixRowSpan: number;
}

export function groupCptAccountPhysicianRows(
  rows: CptByAccountPhysicianRow[]
): GroupedCptAccountPhysicianRow[] {
  return rows.map((row, index) => ({
    row,
    accountRowSpan: spanFrom(rows, index, sameAccount),
    physicianRowSpan: spanFrom(rows, index, samePhysicianGroup),
    prefixRowSpan: spanFrom(rows, index, samePrefixGroup),
  }));
}

function spanFrom(
  rows: CptByAccountPhysicianRow[],
  index: number,
  sameGroup: (
    left: CptByAccountPhysicianRow,
    right: CptByAccountPhysicianRow
  ) => boolean
): number {
  if (index > 0 && sameGroup(rows[index - 1], rows[index])) return 0;
  let end = index + 1;
  while (end < rows.length && sameGroup(rows[index], rows[end])) end += 1;
  return end - index;
}

function sameAccount(
  left: CptByAccountPhysicianRow,
  right: CptByAccountPhysicianRow
): boolean {
  return (
    left.accountType === right.accountType && left.accountId === right.accountId
  );
}

function samePhysicianGroup(
  left: CptByAccountPhysicianRow,
  right: CptByAccountPhysicianRow
): boolean {
  return sameAccount(left, right) && left.physicianId === right.physicianId;
}

function samePrefixGroup(
  left: CptByAccountPhysicianRow,
  right: CptByAccountPhysicianRow
): boolean {
  return samePhysicianGroup(left, right) && left.prefixId === right.prefixId;
}
